/**
 * @generated SignedSource<<be5cdc411170d57c345daa3685591261>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MembershipPlanSelectButton_OrganizationFragment$data = {
  readonly id: string;
  readonly viewerMembershipPlan: {
    readonly id: string;
    readonly viewerCanChangeMembershipPlan: {
      readonly message: string;
      readonly value: boolean;
    };
  };
  readonly " $fragmentType": "MembershipPlanSelectButton_OrganizationFragment";
};
export type MembershipPlanSelectButton_OrganizationFragment$key = {
  readonly " $data"?: MembershipPlanSelectButton_OrganizationFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MembershipPlanSelectButton_OrganizationFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MembershipPlanSelectButton_OrganizationFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "viewerMembershipPlan",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ChangeMembershipPlan",
          "kind": "LinkedField",
          "name": "viewerCanChangeMembershipPlan",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "message",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
})();

(node as any).hash = "aa74c28431546e106d01f2805fedc9f9";

export default node;
